import { RootState } from "app/rootReducer";

const getTokenFromState = (getState: () => RootState) => {
  const { token, userInfo } = getState().login;
  if (!token) throw new Error("Not logged in");
  return { token, userInfo };
};

export { getTokenFromState };
